import { LOCAL_STORAGE } from 'app/commons/constants'
import { getFTLWebAppDomain } from 'app/commons/helpers'

import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { checkEnabledAPIDashboard, checkEnabledEmployess, checkEnabledWallet } from './menuUtils'

function Menu(props) {
  const { t } = useTranslation()
  const configFTL = useSelector((state) => state.configuration.configFTL)
  const { currentEmploy, isLoginAndVerifySms, isBusiness } = props
  const enabledEwalletBusiness = checkEnabledWallet({
    configFTL,
    type: 'business',
  })
  const accessWallet = checkEnabledWallet({ configFTL, type: 'individual' })

  const currentLanguage = localStorage.getItem(LOCAL_STORAGE.DEFAULT_LANGUAGE) || 'id'

  const accessEmployees = checkEnabledEmployess(currentEmploy)
  const accessAPIDashboard = checkEnabledAPIDashboard(currentEmploy)

  // Function
  const isPageCreatingShipment = () => {
    const pathname = window.location.pathname
    return pathname === '/'
  }

  const menuTarger = isPageCreatingShipment ? '_blank' : '_self'
  const ftlWebAppDomain = getFTLWebAppDomain()

  const dropdownMore = () => (
    <>
      {(enabledEwalletBusiness || accessWallet) && (
        <a
          className="Dropdown-Menu-Item"
          href={`${ftlWebAppDomain}/${isBusiness ? 'business/' : ''}credit_balances?lang=${currentLanguage}`}
          target={menuTarger}
        >
          {t('common.wallet')}
        </a>
      )}
      <a className="Dropdown-Menu-Item" target="" href={`${ftlWebAppDomain}/locations?lang=${currentLanguage}`}>
        {t('common.locations')}
      </a>
      {accessEmployees && (
        <a
          className="Dropdown-Menu-Item"
          target=""
          href={`${ftlWebAppDomain}/business/employees?lang=${currentLanguage}`}
        >
          {t('common.employees')}
        </a>
      )}
      <a
        className="Dropdown-Menu-Item"
        target=""
        href={`${ftlWebAppDomain}/preference_drivers?lang=${currentLanguage}`}
      >
        {t('common.my_driver')}
      </a>
      <a
        className="Dropdown-Menu-Item"
        target=""
        href={`${ftlWebAppDomain}/dashboard_analytics?lang=${currentLanguage}`}
      >
        {t('common.dashboard_analytics')}
      </a>
      {accessAPIDashboard && (
        <a
          className="Dropdown-Menu-Item"
          target=""
          href={`${ftlWebAppDomain}/business/api_dashboards?lang=${currentLanguage}`}
        >
          {t('common.api_dashboard')}
        </a>
      )}
    </>
  )

  return (
    <>
      <div className="Menu-Nav-Item Style-Hover item-first">
        <div className="dark-green Dropdown">
          <div className="Dropdown-Close" />
          <div className="Dropdown-Head">
            <div className="Dropdown-Head-Item">{t('common.new_booking')}</div>
            <div className="Dropdown-Head-Caret">
              <i className="xb white material-icons Icon cur-pointer">arrow_drop_down</i>
            </div>
            <div className="top Dropdown-Head-Arrow" />
          </div>
          <div className="left top Dropdown-Menu">
            <a
              className="Dropdown-Menu-Item"
              target=""
              href={`${ftlWebAppDomain}/bookings/new?lang=${currentLanguage}`}
            >
              {t('common.newSingle')}
            </a>
            <a
              className="Dropdown-Menu-Item"
              target=""
              href={`${ftlWebAppDomain}/batches/select?lang=${currentLanguage}`}
            >
              {t('common.batch')}
            </a>
          </div>
        </div>
      </div>
      {/* <div className="menu-item tooltip">
        {t('common.batch')}
        <div className="tooltip-text">
          <div className="wr-box ctn-box1">
            <div className="row-item">
              <div className="item">
                <img src={COMPUTER_BATCH_ICON} alt="" />
              </div>
              <div className="item">
                <img src={EXCEL_BATCH_ICON} alt="" />
              </div>
            </div>
            <div className="row-item ctn-box">
              <div className="item">{t('common.popupText.createMultipleText')}</div>
              <div className="item">{t('common.popupText.createEzSheetText')}</div>
            </div>
            <div className="row-item">
              <div className="item">
                <a
                  className="btn btn-app-exprerience"
                  href={`${ftlWebAppDomain}/bookings/multiple`}
                >
                  {t('common.multiple.title')}
                </a>
              </div>
              <div className="item">
                <a
                  className="btn btn-sheet-upload"
                  href={`${ftlWebAppDomain}/batches/ez_spread_sheet`}
                >
                  {t('common.ezSheetUpload')}
                </a>
              </div>
            </div>
          </div>
        </div>
        <span className="triangle-right">triangle</span>
      </div>
      <div className="menu-item tooltip">
        {t('common.popupText.loadPlan')}
        <div className="tooltip-text">
          <div className="wr-box ctn-box2">
            <div className="row-item">
              <div className="item">
                <img src={MAP_ICON_LOAD_PLAN} alt="" />
              </div>
            </div>
            <div className="row-item ctn-box">
              <div className="item">{t('common.popupText.loadPlanText')}</div>
            </div>
            <div className="row-item">
              <div className="item">
                <a
                  className="btn btn-app-exprerience"
                  href={`${ftlWebAppDomain}/batches/smart_load_planner`}
                >
                  {t('common.smartLoad.title')}
                </a>
              </div>
            </div>
          </div>
        </div>
        <span className="triangle-right">triangle</span>
      </div> */}
      {isLoginAndVerifySms && (
        <>
          <div className="Menu-Nav-Item Style-Hover">
            <div className="dark-green Dropdown">
              <div className="Dropdown-Close" />
              <div className="Dropdown-Head">
                <div className="Dropdown-Head-Item">{t('common.manageBookings')}</div>
                <div className="Dropdown-Head-Caret">
                  <i className="xb white material-icons Icon cur-pointer">arrow_drop_down</i>
                </div>
                <div className="top Dropdown-Head-Arrow" />
              </div>
              <div className="left top Dropdown-Menu">
                <a
                  className="Dropdown-Menu-Item"
                  target=""
                  href={`${ftlWebAppDomain}/bookings?lang=${currentLanguage}`}
                >
                  {t('common.newSingle')}
                </a>
                <a className="Dropdown-Menu-Item" target="" href={`${ftlWebAppDomain}/batches?lang=${currentLanguage}`}>
                  {t('common.batch')}
                </a>
              </div>
            </div>
          </div>
          <div className="Menu-Nav-Item Style-Hover">
            <div className="dark-green Dropdown">
              <div className="Dropdown-Close" />
              <div className="Dropdown-Head">
                <div className="Dropdown-Head-Item">{t('common.more')}</div>
                <div className="Dropdown-Head-Caret">
                  <i className="xb white material-icons Icon cur-pointer">arrow_drop_down</i>
                </div>
                <div className="top Dropdown-Head-Arrow" />
              </div>
              <div className="left top Dropdown-Menu">{dropdownMore()}</div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default Menu
